import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate, IEventUpdate} from "../../services/models/event";
import {toast} from "react-toastify";

export function useUpdateEvent() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [EVENT_ENDPOINTS.UPDATE],
        mutationFn: (createData: IEventUpdate) => EventAPI.update(createData),
        onError() {
            toast.error("Ошибка изменения события");
        },

        onSuccess: () => {
            // Инвалидируем кэш списка событий, чтобы обновить их после создания нового
            queryClient.invalidateQueries({ queryKey: [EVENT_ENDPOINTS.FETCH_EVENTS] });
            toast.success("Событие изменено");
        }
    });
}
